import { render } from "./NewIntegration.vue?vue&type=template&id=6ecb0b14"
import script from "./NewIntegration.vue?vue&type=script&lang=js"
export * from "./NewIntegration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/Modules/Integrations/NewIntegration.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ecb0b14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ecb0b14', __exports__)) {
    api.reload('6ecb0b14', __exports__)
  }
  
  module.hot.accept("./NewIntegration.vue?vue&type=template&id=6ecb0b14", () => {
    api.rerender('6ecb0b14', render)
  })

}


export default __exports__